import eventPanelAuditTile from './tiles/eventPanelAuditTile';

const eventsPanel = angular.module('signalview.eventsPanel', [
    'sfx.data',
    'sfx.ui',
    'signalview.globalEvents',
]);

eventsPanel.component('eventPanelAuditTile', eventPanelAuditTile);
